export default "__VITE_ASSET__DReWfORE__"